import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_app",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "container px-19 py-16" }
const _hoisted_5 = {
  class: "stepper stepper-1 d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px\"><div class=\"stepper-nav d-flex flex-column pt-15\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\"> App Basics </h3><div class=\"stepper-desc\"> Name your App </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\"> App Framework </h3><div class=\"stepper-desc\"> Define your app framework </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">3</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\"> App Database </h3><div class=\"stepper-desc\"> Select the app database type </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">4</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\"> App Storage </h3><div class=\"stepper-desc\"> Select the app storage type </div></div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-wrapper\"><div class=\"stepper-icon\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">5</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\"> Completed! </h3><div class=\"stepper-desc\"> Review and Submit </div></div></div></div></div></div>", 1)
const _hoisted_7 = { class: "d-flex flex-row-fluid justify-content-center" }
const _hoisted_8 = {
  class: "pb-5 current",
  "data-kt-stepper-element": "content"
}
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, "App Basics")
], -1)
const _hoisted_11 = { class: "fv-row mb-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bolder text-dark form-label" }, "Your App Name", -1)
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "fv-row" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between mb-6 cursor-pointer" }
const _hoisted_17 = { class: "d-flex align-items-center me-2" }
const _hoisted_18 = { class: "symbol symbol-50px me-6" }
const _hoisted_19 = { class: "symbol-label bg-light-primary" }
const _hoisted_20 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "Quick Online Courses"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure is just one SEO")
], -1)
const _hoisted_22 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-between mb-6 cursor-pointer" }
const _hoisted_24 = { class: "d-flex align-items-center me-2" }
const _hoisted_25 = { class: "symbol symbol-50px me-6" }
const _hoisted_26 = { class: "symbol-label bg-light-danger" }
const _hoisted_27 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "Face to Face Discussions"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure is just one aspect")
], -1)
const _hoisted_29 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_30 = { class: "d-flex align-items-center justify-content-between mb-6 cursor-pointer" }
const _hoisted_31 = { class: "d-flex align-items-center me-2" }
const _hoisted_32 = { class: "symbol symbol-50px me-6" }
const _hoisted_33 = { class: "symbol-label bg-light-success" }
const _hoisted_34 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "Full Intro Training"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure copywriting")
], -1)
const _hoisted_36 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_37 = {
  class: "pb-5",
  "data-kt-stepper-element": "content"
}
const _hoisted_38 = { class: "w-100" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, " App Framework ")
], -1)
const _hoisted_40 = { class: "fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bolder text-dark mb-7" }, "Select your app framework", -1)
const _hoisted_42 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-warning\"><i class=\"fab fa-html5 text-warning fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">HTML5</span><span class=\"fs-7 text-muted\">Base Web Projec</span></span></span>", 1)
const _hoisted_44 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_45 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-success\"><i class=\"fab fa-react text-success fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">ReactJS</span><span class=\"fs-7 text-muted\">Robust and flexible app framework</span></span></span>", 1)
const _hoisted_47 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_48 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-danger\"><i class=\"fab fa-angular text-danger fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">Angular</span><span class=\"fs-7 text-muted\">Powerful data mangement</span></span></span>", 1)
const _hoisted_50 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_51 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-primary\"><i class=\"fab fa-vuejs text-primary fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">Vue</span><span class=\"fs-7 text-muted\">Lightweight and responsive framework</span></span></span>", 1)
const _hoisted_53 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_54 = {
  class: "pb-5",
  "data-kt-stepper-element": "content"
}
const _hoisted_55 = { class: "w-100" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, " App Database ")
], -1)
const _hoisted_57 = { class: "fv-row mb-12" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bolder text-dark form-label" }, "App Databse Name Name", -1)
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "fv-row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bolder text-dark mb-7" }, "Select your app database solution", -1)
const _hoisted_63 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-success\"><i class=\"fas fa-database text-success fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">MySQL</span><span class=\"fs-7 text-muted\">Basic MySQL database</span></span></span>", 1)
const _hoisted_65 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_66 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-danger\"><i class=\"fab fa-google text-danger fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">Firebase</span><span class=\"fs-7 text-muted\">Google based app data management</span></span></span>", 1)
const _hoisted_68 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_69 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-warning\"><i class=\"fab fa-amazon text-warning fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">DynamoDB</span><span class=\"fs-7 text-muted\">Amazon Fast NoSQL Database</span></span></span>", 1)
const _hoisted_71 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_72 = {
  class: "pb-5",
  "data-kt-stepper-element": "content"
}
const _hoisted_73 = { class: "w-100" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, "App Storage")
], -1)
const _hoisted_75 = { class: "fv-row" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bolder text-dark mb-7" }, "Select your app storage solution", -1)
const _hoisted_77 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-primary\"><i class=\"fab fa-linux text-primary fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">Basic Server</span><span class=\"fs-7 text-muted\">Linux based server storage</span></span></span>", 1)
const _hoisted_79 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_80 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-warning\"><i class=\"fab fa-aws text-warning fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">AWS</span><span class=\"fs-7 text-muted\">Amazon Web Services</span></span></span>", 1)
const _hoisted_82 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_83 = { class: "d-flex align-items-center justify-content-between cursor-pointer mb-6" }
const _hoisted_84 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\"><span class=\"symbol symbol-50px me-6\"><span class=\"symbol-label bg-light-success\"><i class=\"fab fa-google text-success fs-2x\"></i></span></span><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">Google</span><span class=\"fs-7 text-muted\">Google Cloud Storage</span></span></span>", 1)
const _hoisted_85 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_86 = {
  class: "pb-5",
  "data-kt-stepper-element": "content"
}
const _hoisted_87 = { class: "w-100" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark display-6" }, "Complete"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bold fs-3" }, " Review your setup to kickstart your app! ")
], -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder mb-3" }, " App Basics ", -1)
const _hoisted_90 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder mb-3" }, " App Framework ", -1)
const _hoisted_92 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder mb-3" }, " App Database ", -1)
const _hoisted_94 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder mb-3" }, " App Storage ", -1)
const _hoisted_96 = { class: "text-gray-600 fw-bold lh-lg mb-8" }
const _hoisted_97 = { class: "d-flex justify-content-between pt-10" }
const _hoisted_98 = { class: "mr-2" }
const _hoisted_99 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_101 = {
  type: "submit",
  class: "btn btn-lg btn-primary fw-bolder py-4 ps-8 me-3",
  "data-kt-stepper-action": "submit"
}
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_103 = { class: "svg-icon svg-icon-3 ms-2" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" Next Step ")
const _hoisted_105 = { class: "svg-icon svg-icon-3 ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", {
                class: "pb-5 w-100 w-md-400px w-xl-500px",
                novalidate: "novalidate",
                id: "kt_modal_create_app_form",
                onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "appName",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appName) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.appName]
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.appNameError), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Home/Globe.svg" })
                              ])
                            ])
                          ]),
                          _hoisted_21
                        ]),
                        _createElementVNode("span", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            checked: "",
                            name: "appOption1",
                            value: "Quick Online Courses",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.appType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appType]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
                              ])
                            ])
                          ]),
                          _hoisted_28
                        ]),
                        _createElementVNode("span", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption1",
                            value: "Face to Face Discussions",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.appType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appType]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, [
                              _createElementVNode("span", _hoisted_34, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Devices/Watch1.svg" })
                              ])
                            ])
                          ]),
                          _hoisted_35
                        ]),
                        _createElementVNode("span", _hoisted_36, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption1",
                            value: "Full Intro Training",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.appType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appType]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("label", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("span", _hoisted_44, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            checked: "",
                            name: "appOption2",
                            value: "HTML5",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.framework) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.framework]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("span", _hoisted_47, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption2",
                            value: "ReactJS",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.framework) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.framework]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("span", _hoisted_50, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption2",
                            value: "Angular",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.framework) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.framework]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("span", _hoisted_53, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption2",
                            value: "Vue",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.framework) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.framework]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "dbname",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dbName) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.dbName]
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.dbNameError), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("label", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("span", _hoisted_65, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption3",
                            checked: "",
                            value: "MySQL",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.dbType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.dbType]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("span", _hoisted_68, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption3",
                            value: "Firebase",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.dbType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.dbType]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_69, [
                        _hoisted_70,
                        _createElementVNode("span", _hoisted_71, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption3",
                            value: "DynamoDB",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.dbType) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.dbType]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("label", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("span", _hoisted_79, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            checked: "",
                            name: "appOption4",
                            value: "Basic Server",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.storage) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.storage]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_80, [
                        _hoisted_81,
                        _createElementVNode("span", _hoisted_82, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption4",
                            value: "AWS",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.storage) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.storage]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("span", _hoisted_85, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "appOption4",
                            value: "Google",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.data.storage) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.storage]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _hoisted_89,
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.appName), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.appType), 1)
                    ]),
                    _hoisted_91,
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.framework), 1)
                    ]),
                    _hoisted_93,
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.dbName), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.dbType), 1)
                    ]),
                    _hoisted_95,
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.storage), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-light-primary fw-bolder py-4 pe-8 me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.previousStep()))
                    }, [
                      _createElementVNode("span", _hoisted_99, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                      ]),
                      _hoisted_100
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", _hoisted_101, [
                      _hoisted_102,
                      _createElementVNode("span", _hoisted_103, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-primary fw-bolder py-4 ps-8 me-3",
                      "data-kt-stepper-action": "next",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.nextStep()))
                    }, [
                      _hoisted_104,
                      _createElementVNode("span", _hoisted_105, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ], 512)
        ])
      ])
    ])
  ]))
}